import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  image: string;
}

export default function ArticleCard({ slug, title, excerpt, category, date, readTime, image }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all hover:scale-[1.01]"
    >
      <div className="w-full sm:w-48 h-40 sm:h-auto flex-shrink-0 overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
      </div>
      <div className="flex-1 p-4 sm:py-4 sm:pr-4 sm:pl-0 flex flex-col justify-center">
        <div className="flex items-center gap-3 mb-2">
          <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full whitespace-nowrap">
            {category}
          </span>
          <span className="text-xs text-foreground-500">{date}</span>
          <span className="text-xs text-foreground-500">{readTime}</span>
        </div>
        <h3 className="font-heading text-base text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{excerpt}</p>
      </div>
    </Link>
  );
}